import { useEffect, useRef } from 'react'
import { MonitorUp, Square } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { attachVideo } from '@/lib/meetings/rtk'
import { FloatingCard } from './floating-card'

/**
 * What you are sharing, as a small card (board m5gc #4) — the same draggable
 * black surface as the camera card — with "Stop sharing" on it, so the
 * sharer sees what everyone else sees and can stop without hunting for the
 * control bar. Shown only while this tab shares.
 */
export function SharePreview({
  track,
  onStop,
}: {
  track: MediaStreamTrack | null
  onStop: () => void
}) {
  const { t } = useTranslation('meet')
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    if (videoRef.current) attachVideo(videoRef.current, track)
  }, [track])

  return (
    <FloatingCard
      storageKey="hub:meet:share"
      anchor={{ left: 16, bottom: 248 }}
      handleLabel={t('share.title')}
      className="w-40 sm:w-64"
      handleExtra={<MonitorUp className="h-3 w-3 shrink-0 text-emerald-400" aria-hidden />}
    >
      <div className="relative aspect-video w-full bg-black">
        <video ref={videoRef} autoPlay playsInline muted className="h-full w-full object-contain" />
      </div>
      <button
        type="button"
        onClick={onStop}
        className="flex h-8 w-full items-center justify-center gap-1.5 bg-red-600/90 text-xs font-medium text-white transition-colors hover:bg-red-600"
      >
        <Square className="h-3 w-3 fill-current" aria-hidden />
        {t('share.stop')}
      </button>
    </FloatingCard>
  )
}
